<script setup lang="ts">
  import logo from '@/assets/images/logo-sidebar.png'

  const emit = defineEmits<{
    (e: 'toggleSidebarShow'): void,
    // (e: 'toggleSidebarSize'): void,
  }>()

  const companyNameShort = import.meta.env.VITE_APP_COMPANY_NAME_SHORT
</script>

<template>
  <div class="flex items-center justify-between overflow-hidden gap-x-4">
    <div class="shrink-0">
      <app-image
        :src="logo"
        alt="logo"
        class="rounded sidebar-company-icon" />
    </div>
    <div class="shrink-0 flex-1 font-semibold whitespace-nowrap text-xl">
      {{ companyNameShort }}
    </div>
    <!-- <div class="hidden flex-shrink-0 pr-1 text-right lg:block">
      <app-button
        class="text-2xl leading-0"
        @click="emit('toggleSidebarSize')">
        <fa-icon
          icon="i-far-lock"
          class="icon-lock" />
        <fa-icon
          icon="i-far-lock-open"
          class="icon-unlock" />
      </app-button>
    </div> -->
    <app-button
      class="text-2xl lg:hidden"
      @click="emit('toggleSidebarShow')">
      <fa-icon icon="i-fas-xmark" />
    </app-button>
  </div>
</template>
